import React, { useState } from 'react';

import { FormControl, IconButton, InputAdornment, InputLabel, Input, FormHelperText } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';


export default function PasswordField({ label, className, error, helperText, ...others }) {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => event.preventDefault()
    const handleMouseUpPassword = (event) => event.preventDefault()

    return (
        <FormControl error={error} className={className} margin="normal" variant="standard">
            <InputLabel htmlFor="filled-adornment-password">{label}</InputLabel>
            <Input
                size="small"
                id="standard-adornment-password"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                <InputAdornment position="end">
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        onMouseUp={handleMouseUpPassword}
                        edge="end"
                        >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                </InputAdornment>
                }
                {...others}
            />
            <FormHelperText id="component-error-text">{helperText}</FormHelperText>
        </FormControl>
    )
}